import { formatDateStringToObject } from 'syf-js-utilities';
import { format, parse } from 'date-fns';
const DATE_FORMAT_MMMD = 'MMM d';
/** Takes a date and returns it in MMM d format */
export const formatDateString = (date) => {
    if (!date)
        return '';
    return format(formatDateStringToObject(date), DATE_FORMAT_MMMD);
};
export const formatDateToISO = (date) => {
    return format(parse(date, 'MM/dd/yyyy', new Date()), 'yyyy-MM-dd');
};
